import { render, staticRenderFns } from "./BaseAccordionItem.vue?vue&type=template&id=4e7a8882&scoped=true&"
import script from "./BaseAccordionItem.vue?vue&type=script&lang=ts&"
export * from "./BaseAccordionItem.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAccordionItem.vue?vue&type=style&index=0&id=4e7a8882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a8882",
  null
  
)

export default component.exports